import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import {
  AfterContentChecked,
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { SharedService } from 'app/shared/shared.service';
import {AbstractControl, AsyncValidatorFn, FormBuilder, FormControl, ValidatorFn, Validators} from '@angular/forms';
import {AuthService} from '../auth/auth.service';
import {MatDialog} from '@angular/material';
import {LoggerService} from '../logger/logger.service';
import {ProfileService} from '../profile/profile.service';
import {UserNameValidation} from '../auth/rewards/rewards.component';

@Component({
  selector: 'app-email-validation',
  templateUrl: './email-validation.component.html',
  styleUrls: ['./email-validation.component.css']
})
export class EmailValidationComponent implements OnInit, AfterContentChecked {
  // tslint:disable-next-line:max-line-length
  private EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  private MOBILE_REGEX = /^\d{10}$/;
  public is_loading: boolean;
  public isValidating = false;
  public isCheckingOtp = false;
  public email_verified = false;
  public sign_in_data: Object;
  public username: string;
  public password: string;
  sign_in_valid: boolean;
  public signin_text = 'Sign In';
  public keep_me_signed_in: boolean;
  public storedEmail: string;
  public isEmailError = false;
  public isChangeEmailError = false;
  public isEditingEmail = false;
  public isWaitingEditingEmail = false;
  public isChangingEmail = false;
  public isInvalidOtp = false;
  public otpRequestUpdate = false;
  public validEmail = false;
  public editText = 'Edit';
  public is_acc_setting = false;
  public person: object;
  public emailError: string;
  private token: string;
  public pay_by_cash = false;
  public email_verification_required = false;
  public isSignedIn = false;
  public isPinValidated = false;
  public isSigningIn = false;
  public displayAccountPinSubmission = true;
  public userNameForm;
  public is_account_setting: boolean;
  public isOtpSent = false;
  public isCashOnly = false;
  @Input('emailOverride') emailOverride = '';
  @Input('isMobileExpressPay') isMobileExpressPay = false;
  @Input('expressPayAccountNumber') expressPayAccountNumber = undefined;
  @Input('promptChange') promptChange = false;
  @Input('headerTitle') headerTitle;
  @Input('showCashOptions') showCashOptions = false;
  @Input('verifyOnly') verifyOnly = false;
  @Input('isEnrollment') isEnrollment = false;
  @Input('triggerEmailOnLoad') triggerEmailOnLoad = false;
  @Output() onChangeEmail: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCheckVerified: EventEmitter<any> = new EventEmitter<any>();
  @Output() onEmailChanged: EventEmitter<any> = new EventEmitter<any>();
  public emailFormControl = new FormControl('', [
    Validators.pattern(this.EMAIL_REGEX)
  ]);
  passwordFormControl = new FormControl('', [Validators.required]);
  usernameFormControl = new FormControl('', [Validators.required]);
  constructor(
    private router: Router,
    private sharedService: SharedService,
    private localStorageService: LocalStorageService,
    private profileService: ProfileService,
    private logger: LoggerService,
    private dialog: MatDialog,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder
  ) {
    this.userNameForm = fb.group({mobilePhoneFormControl: ['', Validators.required]}, { validator: UserNameValidation.UserNameValidate});
  }

  ngOnInit() {
    this.is_loading = true;
    this.emailFormControl.disable()
    let token: string = this.localStorageService.get('token');
    if (!token) {
      token = this.localStorageService.get('tempToken');
    }
    console.log(token)
    if (token != null) {
      this.sharedService.verifyToken({ token })
        .then((res) => {
          this.is_loading = false;
          if (res.status === 'success' && res.isTerminated === false) {
            this.isSignedIn = true;
            this.token = token;
            const person = res.results[0]['personal'][0];
            this.email_verified = person.isEmailVerify === 1;
            this.onCheckVerifiedCallback(this.email_verified);
            this.isCashOnly = res.cashOnly;
            this.email_verification_required = person.requiresEmailValidation;
            if (!this.email_verified && this.triggerEmailOnLoad) {
              this.resendOTP();
            }
            this.username = this.emailOverride !== '' ? this.emailOverride : person.email;
            this.storedEmail = this.emailOverride !== '' ? this.emailOverride : person.email;
            this.person = person;
            this.validEmail = !!(this.username !== undefined && this.username.trim() !== '' && this.username.match(this.EMAIL_REGEX));
          }
        });
    } else if ((this.emailOverride === undefined || this.emailOverride === '') && this.localStorageService.get('email') != null) {
      this.username = this.emailOverride !== '' ? this.emailOverride : this.localStorageService.get('email');
      this.storedEmail = this.storedEmail = this.emailOverride !== '' ? this.emailOverride : this.username;
      this.validEmail = !!(this.username !== undefined && this.username.trim() !== '' && this.username.match(this.EMAIL_REGEX));
    } else if (this.emailOverride !== '') {
      this.username = this.emailOverride;
      this.validEmail = !!(this.username !== undefined && this.username.trim() !== '' && this.username.match(this.EMAIL_REGEX));
    }
    if (this.isMobileExpressPay) {
      this.authService.isValidOTP(this.expressPayAccountNumber)
        .then((res) => {
          if (!res) {
            this.resendOTP();
          } else {
            this.email_verified = true;
            this.email_verification_required = false;
            this.onCheckVerifiedCallback(true);
          }
        }).catch((err) => {});
    }
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }
  onEmailUpdatedCallback(response: { success: boolean, email: string }) {
    if (response.success) {
      this.localStorageService.set('email', response.email)
      this.onEmailChanged.emit(response)
    }
  }
  onCancelVerification() {
    this.displayAccountPinSubmission = false;
    if (this.isMobileExpressPay) {
      this.email_verified = false;
      this.email_verification_required = true;
      this.isValidating = true;
    }
  }
  onCheckVerifiedCallback(verified: boolean): void {
    this.onCheckVerified.emit(verified)
  }

  onChangeEmailCallback(): void {
    this.onChangeEmail.emit()
  }
  forwardEmailChange() {
    if (this.isMobileExpressPay) {
      this.displayAccountPinSubmission = true;
    }
    this.isValidating = false;
    this.onChangeEmailCallback();
  }

  payByCash() {
    this.pay_by_cash = !this.pay_by_cash;
  }
  editEmailAddress() {
    this.isEditingEmail = true;
    this.emailFormControl.enable()
  }
  emailValidate(email: any) {
    this.isChangingEmail = false;
    this.isChangeEmailError = false;
    this.isEmailError = false;
    if (this.username != null && this.username.trim() !== '') {
      if (this.person['username'].trim() === this.username.trim()) {
        this.email_verified = this.person['isEmailVerify'] === '1';
      } else {
        this.email_verified = false;
      }
    }
    this.validEmail = !!(this.username !== undefined && this.username.trim() !== '' && this.username.match(this.EMAIL_REGEX));
  }

  redirectLocationPage() {
    window.location.href = this.localStorageService.get('msite_base_url') + 'locations';
  }

  saveEmail() {
    if (this.username !== this.storedEmail) {
      this.isChangingEmail = true;
      this.isWaitingEditingEmail = true;
      this.changeEmail();
    } else {
      this.emailFormControl.disable()
      this.isEditingEmail = false;
      this.isChangingEmail = false;
      this.isWaitingEditingEmail = false;
    }
  }
  verifyEmail() {
    if (!this.email_verified) {
      this.resendOTP();
    }
    this.isEditingEmail = false;
    this.isChangingEmail = false;
    this.isWaitingEditingEmail = false;
    this.editText = 'Edit';
  }
  invalidOtp(success: boolean) {
    this.otpRequestUpdate = true;
    this.isInvalidOtp = !!success;
  }
  checkVerified() {
    this.isCheckingOtp = true;
    this.isValidating = true;

    if (this.isMobileExpressPay) {
      this.authService.isValidOTP(this.expressPayAccountNumber)
        .then((res) => {
          if (res) {
            this.email_verified = true;
            this.email_verification_required = false;
            this.onCheckVerifiedCallback(true);
          }
        }).catch((err) => {});
    } else {
      this.sharedService.verifyToken({ 'token': this.localStorageService.get('token') })
        .then((res) => {
          this.is_loading = true;
          if (res.status === 'success' && res.isTerminated === false) {
            this.token = this.localStorageService.get('token');
            const person = res.results[0]['personal'][0];
            this.email_verified = person.isEmailVerify === 1;
            this.email_verification_required = person.requiresEmailValidation;
            this.onCheckVerifiedCallback(this.email_verified);
            this.username = person.email;
            this.person = person;
            this.validEmail = !!(this.username !== undefined && this.username.trim() !== '' && this.username.match(this.EMAIL_REGEX));
            if (this.email_verified) {
              this.isInvalidOtp = false;
              this.isCheckingOtp = false;
              this.isValidating = false;
              this.emailFormControl.enable()
              if (this.headerTitle !== '' && !this.isMobileExpressPay) {
                this.sharedService.setHeaderSuccessMessage(this.headerTitle, true,
                  'You have successfully verified your email address.');
              }
            }
          } else {
            if (this.headerTitle !== '' && !this.isMobileExpressPay) {
              this.emailFormControl.enable()
              this.sharedService.setHeaderErrorMessage(this.headerTitle, true, 'notification error',
                'There was an error validating your email. Please try again later.');
            }
          }
        });
    }
    this.isCheckingOtp = false;
  }

  changeEmail() {
    const methodName = this.constructor.name + '.updateEmail';
    this.profileService.updateEmail({ 'token': this.token, 'email': this.username })
      .then(res => {
        const logObj = {
          method: methodName,
          request: 'token : [masked], email : ' + this.username,
          response: res
        };
        this.logger.logInfo(JSON.stringify(logObj));
        if (res.status === 'success') {
          this.emailFormControl.disable()
          this.isEditingEmail = false;
          this.isChangingEmail = false;
          this.isWaitingEditingEmail = false;
          this.isEmailError = false;
          this.emailError = '';
          this.isChangeEmailError = false;
          this.storedEmail = this.username;
          this.emailFormControl.setErrors({emailInUse: false})
          this.onEmailUpdatedCallback({ success: true, email: this.username })
        } else {
          this.emailFormControl.enable()
          this.emailFormControl.setErrors({emailInUse: true})
          this.isEmailError = true;
          this.isChangeEmailError = true;
          this.isWaitingEditingEmail = false;
          this.emailError = res.message;
          this.isChangingEmail = false;
          this.isEditingEmail = true;
        }
      }, (error) => {
        const logObj = {
          method: methodName,
          request: 'token : [masked], email : ' + this.username,
          exception: error
        };
        this.logger.logError(JSON.stringify(logObj));
        this.emailFormControl.enable()
        this.isEmailError = true;
        this.isChangeEmailError = true;
        this.isChangingEmail = false;
        this.isWaitingEditingEmail = false;
        this.isEditingEmail = true;
      }).catch((ex) => {
      const logObj = {
        method: methodName,
        request: 'token : [masked], email : ' + this.username,
        exception: ex
      };
      this.logger.logError(JSON.stringify(logObj));
      this.emailFormControl.enable()
      this.isEmailError = true;
      this.isChangeEmailError = true;
      this.isChangingEmail = false;
      this.isWaitingEditingEmail = false;
      this.isEditingEmail = true;
    });
  }

  resendOTP() {
    this.isValidating = true;
    this.isInvalidOtp = false;
    this.otpRequestUpdate = false;
    const methodName = this.constructor.name + '.resendOTP';
    this.isMobileExpressPay ?
      this.authService.resendOTPExpress(this.expressPayAccountNumber)
      : this.authService.resendOTP({ 'token': this.token, 'email': this.username, 'sFor': 'email', 'accSetting': this.is_acc_setting })
        .then(res => {
          const logObj = {
            method: methodName,
            request: 'token : [masked]',
            response: res
          };
          if (res.status === 'success') {
            setTimeout(() => {
              this.isOtpSent = false;
            }, 10000);
          } else {
            this.isEmailError = true;
            this.isValidating = false;
            this.emailError = res.message;
          }
        }, (error) => {
          const logObj = {
            method: methodName,
            request: 'token : [masked]',
            exception: error
          };
          this.logger.logError(JSON.stringify(logObj));
        }).catch((ex) => {
          const logObj = {
            method: methodName,
            request: 'token : [masked]',
            exception: ex
          };
          this.logger.logError(JSON.stringify(logObj));
        });
  }

  validatePinResponse(response: { success: boolean, token: string}) {
    if (response.success) {
      this.displayAccountPinSubmission = false;
      if (response.token && response.token !== '') {
        this.sharedService.verifyToken({ token: response.token })
          .then((res) => {
            this.is_loading = false;
            if (res.status === 'success' && res.isTerminated === false) {
              this.isSignedIn = true;
              const person = res.results[0]['personal'][0];
              this.email_verified = person.isEmailVerify === 1;
              this.isCashOnly = res.cashOnly;
              this.email_verification_required = person.requiresEmailValidation;
              if (!this.email_verified && this.triggerEmailOnLoad) {
                this.resendOTP();
              }
              this.username = this.emailOverride !== '' ? this.emailOverride : person.email;
              this.storedEmail = this.emailOverride !== '' ? this.emailOverride : person.email;
              this.person = person;
              this.validEmail = !!(this.username !== undefined && this.username.trim() !== '' && this.username.match(this.EMAIL_REGEX));
              this.token = response.token;
            }
          });
      }
      this.authService.getEmailFromBan(this.expressPayAccountNumber).then((res) => {
        this.username = res.email;
        this.isPinValidated = response.success;
        if (res.email !== undefined && res.email !== null && res.email !== '') {
          this.validEmail = true;
        }
      }).catch((err) => {
        this.isPinValidated = false;
      });
    } else {
      this.isPinValidated = response.success;
    }
  }
  onSignIn(success: boolean) {
    if (success) {
      this.isSigningIn = false;
      this.router.navigate(['./contact-info/AccountSetting'])
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/email/email-validation.component.ts